var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',{attrs:{"title":_vm.t('Activate Account'),"small":true}},[_c('Button',{attrs:{"text":"Send Activation Link"},on:{"click":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }